module.exports = __webpack_public_path__ + "static/hanna-cd628462005b52d8a75fa5241b2760ce.png";